import { hideVisually, rem } from 'polished';
import styled from 'styled-components';

export const StyledColumn = styled.div`
  &:not(:last-child) {
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
      width: 100%;
      margin-bottom: ${rem('24px')};
      padding-bottom: ${rem('24px')};
      border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
    }
  }
`;

export const StyledColumnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const StyledColumnList = styled.ul`
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  font-weight: 400;
  line-height: 1.4;
`;

export const StyledColumnListItem = styled.li`
  display: flex;
  flex-direction: row;
  list-style: none;

  &:not(:last-child) {
    margin-bottom: ${({ theme }) => rem(theme.spacings.s)};
  }

  svg {
    height: 24px;
    width: auto;
  }
`;

export const StyledColumnTitle = styled.strong`
  display: block;
  margin: 0 0 32px 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-weight: 700;
  font-size: ${rem('14px')};
`;

export const StyledColumns = styled.div`
  display: flex;
  flex-direction: row;
`;

export const StyledSecondary = styled.div`
  padding: ${({ theme }) => rem(theme.spacings.s)} 0;
  background-color: ${({ theme }) => theme.colors.cross.ultralightGray};
`;

export const StyledSecondaryList = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('12px')};
  font-weight: 400;
  line-height: 1.4;
`;

export const StyledLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    color: ${({ theme }) => theme.colors.cross.black};
  }
`;

export const StyledPrimary = styled.div`
  padding-top: ${rem('32px')};
  padding-bottom: ${rem('32px')};
  border-top: 1px solid ${({ theme }) => theme.colors.cross.lightGray};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding-top: ${rem('40px')};
    padding-bottom: ${rem('40px')};
  }
`;

export const StyledSecondaryListItem = styled.li`
  margin: ${rem('3px')} 0;
  list-style: none;

  &:not(:last-child) {
    margin-right: ${rem('40px')};
  }

  & ${StyledLink}, & span {
    display: block;
    padding: ${rem('5px')} 0;
  }
`;

export const StyledSocialLink = styled.a`
  margin: ${rem('9px')} 0;
  display: flex;
  flex-direction: row;
  text-decoration: none;

  &:not(:first-child) {
    margin-left: ${({ theme }) => rem(theme.spacings.s)};
    padding-left: ${({ theme }) => rem(theme.spacings.s)};
    border-left: 1px solid ${({ theme }) => theme.colors.cross.lightGray};
  }

  span {
    ${hideVisually()};
  }
`;
